import React, { useRef } from "react";
import vidio from "../assets/vidioBlog/KakaoTalk_Video.mp4"
import { Fullscreen, PauseCircle, PlayCircle } from "lucide-react";

const VideoPlayer: React.FC = () => {
  const videoRef = useRef<HTMLVideoElement>(null);

  const handlePlay = () => {
    videoRef.current?.play();
  };

  const handlePause = () => {
    videoRef.current?.pause();
  };

  const handleFullscreen = () => {
    const video = videoRef.current;
    if (video) {
      if (video.requestFullscreen) {
        video.requestFullscreen();
      } else if ((video as any).webkitRequestFullscreen) {
        (video as any).webkitRequestFullscreen();
      } else if ((video as any).mozRequestFullScreen) {
        (video as any).mozRequestFullScreen();
      } else if ((video as any).msRequestFullscreen) {
        (video as any).msRequestFullscreen();
      }
    }
  };

  return (
    <div className=" flex justify-center items-center">
      <div className="flex flex-col items-center p-4 gap-4">
        <video
          ref={videoRef}
          width="720"
          controls
          className="rounded-lg shadow-lg"
        >
          <source src={vidio} type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        <div className="flex gap-2">
          <button onClick={handlePlay} className=" hover:bg-gray-300 border border-gray-300 rounded-full px-4 py-2 rounded">
            <PlayCircle/>
          </button>
          <button onClick={handlePause} className=" hover:bg-gray-300 border border-gray-300 rounded-full px-4 py-2 rounded">
            <PauseCircle/>
          </button>
          <button onClick={handleFullscreen} className=" hover:bg-gray-300 border border-gray-300 rounded-full px-4 py-2 rounded">
            <Fullscreen/>
          </button>
        </div>
      </div>
    </div>
  );
};

export default VideoPlayer;
